var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "white",
    stroke: "#4B3986"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8959 7.848C10.9599 7.848 9.80788 8.37 8.96188 9.252L9.33988 6.372C10.2939 5.886 11.1039 5.58 12.3099 5.58C14.6859 5.58 16.0539 7.146 16.0539 8.964C16.0539 10.494 14.9559 11.322 14.3079 11.862C13.4259 12.6 12.8139 13.104 12.5799 14.148H11.4819C11.0139 12.978 11.5719 11.808 12.2199 11.052C12.5979 10.602 13.4079 10.062 13.4079 9.252C13.4079 8.55 12.8859 7.848 11.8959 7.848ZM12.1839 18.144C11.3739 18.144 10.7079 17.46 10.7079 16.668C10.7079 15.84 11.3739 15.156 12.1839 15.156C12.9939 15.156 13.6599 15.84 13.6599 16.668C13.6599 17.46 12.9939 18.144 12.1839 18.144Z",
    fill: "#9284BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.4cbee9617d1fea1b490bb2baa4de0d7a.svg";
export { ForwardRef as ReactComponent };